// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__-AK0d","card-wrapper":"cards_card-wrapper__nEn+7","slider":"cards_slider__cZTUi","grid_dot":"cards_grid_dot__X5kk4","slice_slide":"cards_slice_slide__9dVUd"};